import { ConfigProvider, Drawer } from "antd";
import style from "css/room.module.css";
import axios from "axios";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { LeftOutlined } from "@ant-design/icons";

function Location({ isOpen, location, setLocation, onClose }) {
  const [init, setInit] = useState(true);
  const [isListOpen, setIsListOpen] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [level, setLevel] = useState(0);
  const [maxLevel, setMaxLevel] = useState(0);
  const [locationList, setLocationList] = useState([]);
  const [renderList, setRenderList] = useState([]);
  const [selectLocation, setSelectLocation] = useState([]);
  const [isAccept, setIsAccept] = useState(false);

  const getLocationList = useCallback(() => {
    axios
      .get("/schedule/department")
      .then((res) => {
        const list = [];
        for (const value in res.data) {
          res.data[value].forEach((location) => {
            if (location.LEVEL > maxLevel) setMaxLevel(location.LEVEL);

            list.push({
              level: location.LEVEL,
              id: location.DEPT_CD,
              label: location.DEPT_NM,
              parent_id: location.PAR_CD,
            });
          });
        }
        setLocationList(list);
        setIsRender(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [maxLevel]);

  const renderItem = useCallback(() => {
    const list = [];
    locationList.forEach((location) => {
      if (location.level === level) {
        if (
          (selectLocation.length > 0 &&
            location.parent_id ===
              selectLocation[selectLocation.length - 1].id) ||
          location.parent_id === ""
        ) {
          list.push(location);
        }
      }
    });

    if (list.length > 0) {
      setRenderList(list);
    } else {
      setIsListOpen(false);
    }
  }, [level, locationList, selectLocation]);

  useLayoutEffect(() => {
    if (init) {
      getLocationList();
      setInit(false);
    }
  }, [getLocationList, init]);

  useEffect(() => {
    if (isListOpen && isRender) {
      renderItem();
      setIsRender(false);
    }
  }, [isListOpen, isRender, renderItem]);

  useEffect(() => {
    if (selectLocation.length > 0) {
      setIsAccept(true);
    } else {
      setIsAccept(false);
    }
  }, [selectLocation.length]);

  const onReset = () => {
    setLevel(0);
    setMaxLevel(0);
    setLevel(0);
    setSelectLocation([]);
    setRenderList([]);
    setIsAccept(false);
    setInit(true);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          padding: "0",
          paddingLG: "0",
          paddingXS: "0",
        },
      }}
    >
      <Drawer
        open={isOpen}
        closable={false}
        width="100%"
        height="100%"
        placement="bottom"
        style={{
          padding: "0px 20px",
        }}
      >
        <section
          className={style.location_drawer}
          onClick={() => {
            if (isOpen) {
              setIsListOpen(false);
            }
          }}
        >
          <section className={style.location_drawer_header}>
            <LeftOutlined
              onClick={onClose}
              className={style.location_drawer_close}
            />
            <p className={style.location_drawer_title}>회의실 위치</p>

            <p
              className={
                isAccept
                  ? `${style.location_drawer_accept} ${style.active}`
                  : style.location_drawer_accept
              }
              onClick={() => {
                if (isAccept) {
                  onClose();

                  setTimeout(() => {
                    setLocation(selectLocation[selectLocation.length - 1]);
                    onReset();
                  }, 500);
                }
              }}
            >
              완료
            </p>
          </section>

          <section className={style.location_drawer_body}>
            <p className={style.location_drawer_subtitle}>위치</p>

            <div
              className={
                selectLocation.length > 0
                  ? style.location_drawer_indicator
                  : location.id !== ""
                  ? style.location_drawer_indicator
                  : `${style.location_drawer_indicator} ${style.placeholder}`
              }
              onClick={(e) => {
                e.stopPropagation();
                if (!isListOpen) {
                  onReset();
                  setIsListOpen(true);
                  setIsRender(true);
                }
              }}
            >
              {selectLocation.length > 0
                ? selectLocation[selectLocation.length - 1].label
                : location.id !== ""
                ? location.label
                : "위치를 선택해 주세요."}
            </div>

            {isListOpen && (
              <div className={style.location_drawer_list}>
                {level > 0 && (
                  <div
                    className={`${style.location_drawer_item} ${style.back}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLevel(level - 1);
                      setSelectLocation(
                        selectLocation.filter(
                          (location) =>
                            location.id !==
                            selectLocation[selectLocation.length - 1].id
                        )
                      );
                      setIsRender(true);
                    }}
                  >
                    <LeftOutlined />
                    <p>이전</p>
                  </div>
                )}
                {renderList.map((el, idx) => (
                  <div
                    key={idx}
                    className={
                      el.id === selectLocation.id
                        ? `${style.location_drawer_item} ${style.selected}`
                        : style.location_drawer_item
                    }
                    onClick={(e) => {
                      e.stopPropagation();

                      if (el.level <= maxLevel - 1) setLevel(level + 1);

                      setSelectLocation([
                        ...selectLocation,
                        {
                          id: el.id,
                          label: el.label,
                        },
                      ]);
                      setIsRender(true);
                    }}
                  >
                    {el.label}
                  </div>
                ))}
              </div>
            )}
          </section>
        </section>
      </Drawer>
    </ConfigProvider>
  );
}

export default Location;
